	var default_affiliate = "psmedia";
	var default_days = 180;
	var default_entry = "/";
	
	var aff = default_affiliate;
	var days = default_days;
	var entry = default_entry;
	
	// Creates an object from the query string parameters
	var QueryString = function () {
  		var query_string = {};
  		var query = window.location.search.substring(1);
  		var vars = query.split("&");
  		for (var i=0;i<vars.length;i++) {
    		var pair = vars[i].split("=");
    		if(typeof query_string[pair[0]] === "undefined") {
      			query_string[pair[0]] = pair[1];
    		}else if(typeof query_string[pair[0]] === "string") {
      			var arr = [ query_string[pair[0]], pair[1] ];
      			query_string[pair[0]] = arr;
    		}else{
      			query_string[pair[0]].push(pair[1]);
    		}
  		}	 
    	return query_string;
	}();
	
	// Affiliate can be specified in URL instead of default
	if(QueryString.a) {
		$aff = QueryString.a;
	}
	
	// Days can be overridden
	if(QueryString.d) {
		days = parseInt(QueryString.d);
		if(days <= 0) {
			days = default_days;
		}
	}
	
	// Entry URL can be specified
	if(QueryString.e){
		entry = QueryString.e;
      	if(QueryString.gclid){
          separator = '?';
          gclid = QueryString.gclid;

          if (decodeURIComponent(entry).indexOf('?') > -1) {
              separator = '&';
          }

          entry = entry + separator + 'gclid=' + gclid;
      }
	}
	
	// Store first party cookie that will be used to conditionally change elements on customers website.
	var expdate = new Date();
		expdate.setTime(expdate.getTime() + (days*24*60*60*1000));
	var expires = "; expires="+expdate.toGMTString();
	
	// Set cookie
	//document.cookie = 'psmaff='+aff+expires+"; path=/";
	document.cookie = 'psmaff='+aff+expires+";domain=.designpublic.com;path=/";
	
	// Redirect the customer to the entry page
	var host = window.location.host;

	if(QueryString.mobile && QueryString.mobile == 1){
      host = 'amp.designpublic.com';
    }

	window.location = "https://" + host + decodeURIComponent(entry);	